<template>
  <div>
    <b-modal
      :ok-disabled="disabled_button"
      ok-only
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      no-enforce-focus
      id="modal-prevent-closing"
      v-model="test"
      @cancel="exit"
      ok-variant="danger"
    >
      <template  slot="modal-title"><h4 class="my-auto mx-auto form-header">{{'confirmMailH1' | localize}}</h4> </template>
      <form 
        class="change-mail-form p-2 m-2" 
        novalidate
        @submit.prevent="checkKodFromMail" 
      >
      
        <div class="new-address-description ">{{'confirmMailDescription' | localize}} {{user_mail}}</div>
        <b-button 
          class="my-3 style-button button-profile"
          @click="sendMessageInMail"
          variant="outline-danger"
          v-if="send_button"
        >
          {{'confirmPhoneSendButton' | localize}} <div class="style-button-icon"> <b-icon  icon="mailbox" ></b-icon> </div> 
        </b-button>
        <div v-if="!send_button" class="form-header"> {{'confirmMailSendDescription' | localize}} email</div>
        <div class="new-address-description ">{{'confirmMailFormDescription' | localize}}:</div>
        <input 
          v-model="mail_cod_send"
          type="text"
          class="form-control"
        >
        <div 
            class="form-description-error"
            v-if="$v.mail_cod_send.$dirty && !$v.mail_cod_send.required"
        >
            {{'newAddressRequiredInput' | localize}}
        </div> 
          <b-button 
            class="my-3 mb-5 style-button button-profile"
            variant="outline-danger"
            type="submit"
          >
            {{'confirmPhoneCheckButton' | localize}} <div class="style-button-icon"> <b-icon  icon="mailbox" ></b-icon> </div> 
          </b-button>
          <b-button class="my-auto" @click="change_mail= !change_mail" variant="secondary">{{'confirmMailChangeButton' | localize}} email</b-button>
      </form>
      

      <ChangeMailInConfirmForm v-if="change_mail" @editData="editData"></ChangeMailInConfirmForm>

      <template slot="modal-ok" disabled > {{'confirmMailChangeEndButton' | localize}} </template>
    </b-modal> 
  </div>

</template>
<script>
import config from '@/config'
const ROUTE_PREFIX = config.ROUTE_PREFIX

import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import ChangeMailInConfirmForm from './ChangeMailInConfirmForm'
export default {
  components: { ChangeMailInConfirmForm },
  props: ['modal1_mail_confirm'],
  mixins: [validationMixin],
  data: ()=> ({
    change_mail: false,
    disabled_button: true,

    mail_cod_send: '',
    user_mail: localStorage.weltum_user_mail,
    message: '',
    mail_kod_answer: '',

    send_button: true,
    test: false
  }),
  validations: {
      mail_cod_send: {required},
  },
  mounted(){
    this.test = this.modal1_mail_confirm
  },
  computed: mapGetters(['locale', 'mail_message', 'mail_kod']),
  methods: {
    async exit(){
        localStorage.removeItem("weltumLastUrl")
        await this.$store.dispatch('logout') 
        this.$router.push( { path: `${ROUTE_PREFIX}/login` } )
    },
    async sendMessageInMail(){
      const MESSAGE = {
        login: localStorage.weltumAuth,
        mail: localStorage.weltum_user_mail
      }
      await this.$store.dispatch('sendSessageToMail', MESSAGE)
      this.message = this.mail_message
      if(this.mail_message === 'OK'){
        this.$messageLocalized("confirmationCodeSent")
      }
      this.send_button = false
      setTimeout( ()=> {
        this.send_button = true
      }, 30000)
    },
    async checkKodFromMail(){
      if(this.$v.$invalid){
        this.$v.$touch()
      } else {
        const KOD = {
          login: localStorage.weltumAuth,
          mail: localStorage.weltum_user_mail,
          pass_confir: this.mail_cod_send
        }
        await this.$store.dispatch('checkMessage', KOD)
        this.mail_kod_answer = this.mail_kod
        if(this.mail_kod_answer === 'Ошибка подтверждения !') {
          this.$messageLocalized("wrongData")
        } else if (this.mail_kod_answer === 'OK') {
          this.$messageLocalized("dataConfirmed")
          this.disabled_button = false   
        }
      }

    },

    editData(mail_changed, new_mail){
      this.change_mail = mail_changed
      this.user_mail = new_mail
    }
  }
  
}
</script>
